import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";

export const AttemptsBreakdown = () => {
  const pieChart = useSelector((state) => state.draft.chartsData.pieChart);

  if (!pieChart || !pieChart.data_table) return null;

  const { cols, rows } = pieChart.data_table;
  const { options } = pieChart;

  if (!rows || !rows.length || rows.every((row) => row[1] === 0))
    return (
      <>
        <p style={{ color: "#414042", fontWeight: "bold" }}>Attempts Breakdown</p>
        <NoData size="medium" />
      </>
    );

  return (
    <GoogleChart
      width="100%"
      height={300}
      chartType="PieChart"
      columns={cols}
      rows={rows}
      options={{ ...commonOptions, ...options }}
      showCurrency={false}
      showAdditionTooltip={false}
      showXLSX={false}
    />
  );
};
